module.exports = __webpack_public_path__ + "img/section_title.f8202ac1.png";